<template>
    <div>

        <!-- URGENT POPUP -->
        <v-layout v-if="urgentData && !getAppPropertyStudyAccess" row justify-center>
            <v-dialog v-model="mustShowUrgentPopup" content-class="urgent-popup-dialog" persistent max-width="600" id="close-popup">
                <v-card class="no-padding">
                    <v-card-text class="text-center no-padding">

                        <div class="warning-ambulance" v-bind:style="getAppPropertyValue('GUI_THEME_URGENCY_COLOR_BACKGROUND') ? {'background-color':getAppPropertyValue('GUI_THEME_URGENCY_COLOR_BACKGROUND') + ' !important'} : {'background-color': '#a0001c' + ' !important'}">
                            <div class="close-warning">
                                <span @click="hideUrgentPopup()" id="btnUrgentPopupClose">
                                    <img alt="close icon" src="../../../assets/svg/material-icons-alternatives/Close_White.svg" width="24px" height="24px">
                                </span>
                            </div>

                            <div style="display:block;position:relative" class="warning-icon-urgent-popup">
                                <img src="../../../assets/svg/Emergency.svg" id="urgentPopupWarningIcon" width="104" height="104" alt="Emergency">
                            </div>

                            <div class="color-white" v-bind:style="getAppPropertyValue('GUI_THEME_URGENCY_COLOR_TEXT')  ? {'color': getAppPropertyValue('GUI_THEME_URGENCY_COLOR_TEXT') + ' !important'}: {}">
                                <h2 class="font-weight-regular" id="urgentPopupDecisionItem1Headline" v-html="urgentData.decisionItem1Headline"></h2>
                                <p v-if="urgentData.decisionItem1Text" id="urgentPopupDecisionItem1Text" v-html="urgentData.decisionItem1Text">

                                </p>

                                <div v-if="urgentData.decisionItems2Texts">
                                    <br />
                                    <ul>
                                        <li v-for="(decisionItems2Text, index) in urgentData.decisionItems2Texts"
                                            :id="'urgentPopupDecisionItems2Text_' + index"
                                            v-html="decisionItems2Text"
                                        ></li>
                                    </ul>
                                </div>

                                <p v-if="urgentData.emergencyNumber" id="urgentPopupEmergencyNumber">Emergency number: {{ urgentData.emergencyNumber</p>
                            </div>
                        </div>
                        <div class="arrow-down" v-bind:style="getAppPropertyValue('GUI_THEME_URGENCY_COLOR_BACKGROUND') ? {'border-top-color': getAppPropertyValue('GUI_THEME_URGENCY_COLOR_BACKGROUND') + ' !important'} :  {'border-top-color': '#a0001c' + ' !important'}"></div>

                    </v-card-text>
                    <v-card-actions class="text-center warning-actions component-bg-color">

                        <div class="continue">
                            <v-btn @click="gotoScoringPage()" id="btnUrgentPopupFinish" class="btn-evaluation" color="primary">{{text('api.button.finish')}}</v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';

import WarningIcon from "../../../common/components/svg/shared/warningIcon";

export default {
        name: 'UrgentPopup',
        components: {
           WarningIcon
        },
        computed: {
            ...mapGetters({
                urgentData: 'AssessmentAlertsStore/getUrgentData',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                decisionColor: 'AssessmentAlertsStore/getDecisionColor',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            })
        },

        methods: {

            hideUrgentPopup() {
                this.$store.commit('AssessmentAlertsStore/setMustShowUrgentPopup', false);
            },

            handleKeyDowns(evt) {

                if (this.mustShowUrgentPopup === false) {
                    return;
                }

                if (evt.repeat === true) {
                    // Prevent handling the event multiple times if the user holds the key pressed.
                    return;
                }

                switch (evt.keyCode) {

                    // Backspace
                    case 8:
                        evt.preventDefault();
                        evt.stopPropagation();
                        evt.stopImmediatePropagation();
                        return false

                    case 35:
                        // Shift + End => go to scoring page (Finish button)
                        if (evt.shiftKey === true && evt.altKey === false && evt.ctrlKey === false) {
                            // on Mozilla Firefox selects the title popup
                            evt.preventDefault();
                        }

                }
            },

            handleKeyUps(evt) {

                switch (evt.keyCode) {

                    // Tab
                    case 9:
                        evt.preventDefault();
                        evt.stopPropagation();
                        evt.stopImmediatePropagation();
                        return false;

                }

                if (this.mustShowUrgentPopup === false) {
                    return;
                }

                switch (evt.keyCode) {

                    case 27:
                        // Escape
                        this.hideUrgentPopup();
                        break;

                    case 35:
                        // Shift + End => go to scoring page (Finish button)
                        if (evt.shiftKey === true && evt.altKey === false && evt.ctrlKey === false) {
                            this.gotoScoringPage();
                        }
                        break;

                }
            },

            gotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: false,
                    urgentEvaluate: true
                });

                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$store.commit('AssessmentAlertsStore/setMustShowUrgentPopup', false);

                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            }
        },

        created: function() {
            document.addEventListener('keydown', this.handleKeyDowns);
            document.addEventListener('keyup', this.handleKeyUps);
        },

        destroyed: function() {
            document.removeEventListener('keydown',this.handleKeyDowns);
            document.removeEventListener('keyup',this.handleKeyUps);
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    /*.warning-ambulance {
        position:relative;
        background-color: $color-brand-primary;
        height:auto !important;
        width:100% !important;
        color: $color-lightest;
        padding: 10px 20px 20px 20px;

        ul li {
            list-style-type: none;
        }
    }*/

   /* .arrow-down {
        width: 0;
        height: 0;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        right: 47%;
        border-top: 20px solid;
        position: absolute;
        border-top-color: $color-brand-primary;
    }

    .close-warning {

        padding-bottom: 50px;



        span {

            float: right;
            padding: 10px;

            .icon {
                color: $color-lightest;
            }

            &:hover {
                cursor: pointer;
            }
        }


    }

    .warning-actions {
        display: block;
        border-top: none;
        padding: 40px 0 20px;


        .continue {
            padding: 0 20px;

            &:hover {
                cursor: pointer;
            }
        }
    }*/

</style>



// WEBPACK FOOTER //
// src/common/components/shared/UrgentPopup.vue